export enum InventoryBySerialNumberStatusEnum {
  Sold = 'Sold',
  OnHand = 'OnHand',
  Consumed = 'Consumed',
  Expired = 'Expired',
  InActive = 'In Active',
}
